import styled from 'styled-components';

const AreaLogo = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextLogo = styled.h1`
  font-size: xxx-large;
  letter-spacing: 2px;
`;

const NumberLogo = styled.span`
  font-family: "WinkleRegular";
`;

export { AreaLogo, TextLogo, NumberLogo };
